var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 24C2.5 24.9283 2.86875 25.8185 3.52513 26.4749C4.1815 27.1313 5.07174 27.5 6 27.5H27C27.9283 27.5 28.8185 27.1313 29.4749 26.4749C30.1313 25.8185 30.5 24.9283 30.5 24V14.375H2.5V24ZM6.625 19.25C6.625 18.7527 6.82254 18.2758 7.17417 17.9242C7.52581 17.5725 8.00272 17.375 8.5 17.375H11.5C11.9973 17.375 12.4742 17.5725 12.8258 17.9242C13.1775 18.2758 13.375 18.7527 13.375 19.25V20.5C13.375 20.9973 13.1775 21.4742 12.8258 21.8258C12.4742 22.1775 11.9973 22.375 11.5 22.375H8.5C8.00272 22.375 7.52581 22.1775 7.17417 21.8258C6.82254 21.4742 6.625 20.9973 6.625 20.5V19.25ZM27 5.5H6C5.07174 5.5 4.1815 5.86875 3.52513 6.52513C2.86875 7.1815 2.5 8.07174 2.5 9V10.625H30.5V9C30.5 8.07174 30.1313 7.1815 29.4749 6.52513C28.8185 5.86875 27.9283 5.5 27 5.5Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard);
export default __webpack_public_path__ + "static/media/icon_card.9a7826a0ed1cd1c44520978b08dcf11f.svg";
export { ForwardRef as ReactComponent };